import React from 'react'
import { AppLinearProgress } from '@components'
import { Box, Typography } from '@mui/material'
import { globalExecutionsTableBatchCellData } from 'Pages/Admin/GlobalExecution/@signals'
import { REPORT_STATUS } from '@constants'
import {LoadingText} from "Pages/Main/Home/@components";
import { reportSearchesModalId } from '@signals'
import { useComputed } from '@preact/signals-react'



export default function historyColumn() {

	return [{
		name: 'id_batch', label: 'Status',
		options: {
			display: 'excluded',
		},
	},{
		name: 'id_batch', label: 'Status',
		options: {
			filter: false,
			customBodyRowRenderLite: (idBatch, row) => <CellContent idBatch={idBatch} row={row}/>,
		},
	}]
}


function CellContent({ idBatch, row }) {
	const rowData = useComputed(() => ({ ...row, ...globalExecutionsTableBatchCellData.value[idBatch] }))

	return <Box
		sx={{
			cursor: !rowData?.value?.generating ? 'pointer' : '',
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'center',
			width: 1,
		}}
		onClick={() => {
			if (rowData.value?.status !== REPORT_STATUS.GENERATING) {
				reportSearchesModalId.value = rowData.value?.id_batch
			}
		}}>
		<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: 1, mb: 0.5 }}>
			<LoadingText label={!rowData?.value?.generating ? 'Running' : 'Generating'}></LoadingText>
			{!rowData?.value?.generating && <Typography variant="body2" color="text.secondary" sx={{ ml: 0.5 }}>
				{rowData?.value?.completeTasksString || 0}/{rowData?.value?.totalTasksString || 0}
			</Typography>}
		</Box>
		<Box sx={{ width: 1 }}>
			<AppLinearProgress actual={rowData?.value?.percentage} total={100} generating={rowData?.value?.generating}/>
		</Box>
		<Box sx={{ width: 1 }}>
			<Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.7rem', textAlign: 'center' }}>
				{!rowData?.value?.generating && 'Click progress bar to view details'}
			</Typography>
		</Box>
	</Box>
}